/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import {
  ScrollView,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Content = (props: ContentProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <ScrollView
      contentContainerStyle={styles.container}
      showsVerticalScrollIndicator={false}
      nestedScrollEnabled={true}
      style={[
        styles.widgetInner,
        props.noMargin && styles.widgetInnerNoMargin,
        props.noBackground && styles.widgetInnerNoBackground,
        props.style,
      ]}
    >
      {props.children}
    </ScrollView>
  );
};

class ContentProps {
  children: React.ReactNode;

  style?: any;
  noMargin?: boolean;
  noBackground?: boolean;
};

export default Content;
